import React, { Fragment } from "react";
import ProductDescriptionTab from "./ProductDescriptionTab";
import ProductImageDescriptionSlider from "./ProductImageDescriptionSlider";
import RelatedProductSlider from "./RelatedProductSlider";

const ProductDetail = ({ product, source }) => {
    return (
        <Fragment>
            {/* product description with image */}
            <ProductImageDescriptionSlider product={product} />

            {/* product description tab */}
            {product.fullDescription && <ProductDescriptionTab productFullDesc={product.fullDescription} />}

            {/* related product slider */}
            {product.category && product.category[0] && <RelatedProductSlider categoryId={product.category[0]["@id"]} source={source} />}
        </Fragment>
    );
};

export default ProductDetail;
